import Title from '../../../atoms/Title'
import Videosprojector from './Videosprojector'
import { useTranslation } from 'react-i18next'


export default function Videossection({videos}) {
  const { t } = useTranslation();

  return (
    <div className=' h-full my-[4px] mt-[14px] overflow-hidden'>
            <div className='h-1/6 flex justify-start items-center ms-[25px] '>
                  <div className='pb-[8px]'>

                    <Title primary>{t("home.videos.title")}</Title>
                  </div>  
                <div className="h-[3px] w-full bg-[#F5F5F5] mx-[20px] md:mx-[20px] lg:mx-[80px]"></div>
            </div>

            <div className='h-full mx-[30px] flex flex-col justify-start items-center'>
                <Videosprojector videos={videos}/>
            </div>
    </div>
  )
}
